import { useRouter } from 'next/router'
import { useStaticPageQuery, StaticPageDocument, StaticPageQuery } from '~/src/generated/graphql'
import { BaseLayout } from '~/src/components/shared/layout'
import { SectionHeader } from '~/src/components/shared'
import { PostContent } from '~/src/components/post/PostContent'

interface PageProps {
	pageData: StaticPageQuery 
}

function StaticPage({ pageData }: PageProps) {
  const router = useRouter()

  const { data, loading } = useStaticPageQuery({
    variables: {
      where: {
        path: router.asPath 
      }
    },
    skip: Boolean(pageData)
  })

  const page = (data || pageData)?.staticPages?.[0]


  if (loading) return null
  if (!page) {
    router.push('/')
    return null
  }

  const { title, content } = page

  return (
    <BaseLayout>
      <div className='max-w-screen-xl mx-auto px-4'>
        <div className="my-20">
          <SectionHeader
            title={title}
            variant="primary"
            className="mb-20" /> 
          <div style={{ minHeight: 500 }}>
            <PostContent content={content} />
          </div>
        </div>
      </div>
    </BaseLayout>
  )
}

StaticPage.getInitialProps = async (ctx: any) => {
  if (typeof window === 'object') return { props: { } }

  const { req, res } = ctx

  const pageData = await ctx.apolloClient.query({
    query: StaticPageDocument,
    variables: {
      where: {
        path: req.url
      }
    }
  })

  const page = pageData?.data?.staticPages?.[0]

  if (!page) {
    res.statusCode = 404
    res.end('not found')
    return
  }

  return {
    props: {
      pageData
    }
  }
}

export default StaticPage